<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            🧪 Teste de Conexão com Backend
          </v-card-title>
          
          <v-card-text>
            <v-alert
              v-if="status === 'success'"
              type="success"
              text
            >
              ✅ Conexão OK! Backend respondeu com sucesso.
            </v-alert>

            <v-alert
              v-if="status === 'error'"
              type="error"
              text
            >
              ❌ Erro na conexão: {{ errorMessage }}
            </v-alert>

            <v-simple-table v-if="platformStats">
              <tbody>
                <tr>
                  <td><strong>Status do Backend:</strong></td>
                  <td>{{ status }}</td>
                </tr>
                <tr v-for="(value, key) in platformStats" :key="key">
                  <td><strong>{{ key }}:</strong></td>
                  <td>{{ value }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="primary"
              :loading="loading"
              @click="testConnection"
            >
              <v-icon left>mdi-connection</v-icon>
              Testar Conexão
            </v-btn>

            <v-btn
              color="secondary"
              @click="testUsers"
            >
              <v-icon left>mdi-account</v-icon>
              Testar Usuários
            </v-btn>

            <v-btn
              color="info"
              @click="testCampaigns"
            >
              <v-icon left>mdi-bullhorn</v-icon>
              Testar Campanhas
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Detalhes da Resposta -->
    <v-row v-if="responseData">
      <v-col cols="12">
        <v-card>
          <v-card-title>📋 Resposta do Servidor</v-card-title>
          <v-card-text>
            <pre style="background: #f5f5f5; padding: 15px; border-radius: 4px; overflow-x: auto;">{{ responseData }}</pre>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { PlatformService, UsersService, CampaignsService } from '@/services'

export default {
  name: 'TestAPI',

  data: () => ({
    loading: false,
    status: null,
    errorMessage: '',
    platformStats: null,
    responseData: null,
  }),

  methods: {
    async testConnection() {
      this.loading = true
      this.status = null
      this.errorMessage = ''
      this.responseData = null

      try {
        console.log('🔄 Testando conexão com /api/platform/dashboard...')
        
        const response = await PlatformService.getStats()
        
        console.log('✅ Resposta recebida:', response)
        
        this.status = 'success'
        this.platformStats = response.data
        this.responseData = JSON.stringify(response.data, null, 2)
      } catch (error) {
        console.error('❌ Erro na conexão:', error)
        
        this.status = 'error'
        this.errorMessage = error.response?.data?.message || error.message || 'Erro desconhecido'
        this.responseData = JSON.stringify({
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
          message: error.message,
        }, null, 2)
      } finally {
        this.loading = false
      }
    },

    async testUsers() {
      this.loading = true
      this.status = null
      this.responseData = null

      try {
        console.log('🔄 Testando /api/users...')
        
        const response = await UsersService.list({ page: 0, size: 10 })
        
        console.log('✅ Usuários recebidos:', response)
        
        this.status = 'success'
        this.responseData = JSON.stringify(response.data, null, 2)
      } catch (error) {
        console.error('❌ Erro ao buscar usuários:', error)
        
        this.status = 'error'
        this.errorMessage = error.response?.data?.message || error.message
        this.responseData = JSON.stringify({
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
        }, null, 2)
      } finally {
        this.loading = false
      }
    },

    async testCampaigns() {
      this.loading = true
      this.status = null
      this.responseData = null

      try {
        console.log('🔄 Testando /api/campaigns...')
        
        const response = await CampaignsService.list()
        
        console.log('✅ Campanhas recebidas:', response)
        
        this.status = 'success'
        this.responseData = JSON.stringify(response.data, null, 2)
      } catch (error) {
        console.error('❌ Erro ao buscar campanhas:', error)
        
        this.status = 'error'
        this.errorMessage = error.response?.data?.message || error.message
        this.responseData = JSON.stringify({
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
        }, null, 2)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
